import React from 'react'
import { connect } from "react-redux";
import NavigationTabs from '../nav/NavigationTabs';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ButtonContent from '../ButtonContent'
import MenuItem from '@material-ui/core/MenuItem';
import withAuth from '../../hocs/withAuth';
import { fetchUser, updateUser } from "../../store/actions/auth"
import { getSubscriptionPlans } from "../../store/actions/payments"

class PartnerSubscription extends React.Component {
  state = {
    dataLoaded: false,
    plans: [],
    planId: ''
  }

  componentDidMount() {
    const { fetchUser, getPlans } = this.props;
    fetchUser().then((res) => {
      this.setState({
        planId: res.subscriptionPlan
      })
    });
    getPlans().then((res) => {
        this.setState({
          plans: res
        })
      });
    this.setState({ ...this.state, dataLoaded: true })
  }

  renderMenuOptions = option => {
		return (
			<MenuItem key={option._id} value={option._id}>
				{option.name}
			</MenuItem>
		);
  };

  updatePlan() {
    const { planId } = this.state;
    if(planId) {
      this.props.updateUser({
        subscriptionPlan:planId
      }).then((data) => {})
    }
  };

  renderPlanSelect() {
    const { plans, planId } = this.state;
   	if (Object.keys(plans).length > 0) {
			return (
				<TextField
					select
					label="Plan"
					value={planId}
					onChange={e => this.setState({ planId: e.target.value })}
					margin="dense"
					variant="outlined"
					style={{ width: 200 }}
				>
				{Object.values(plans).map(this.renderMenuOptions)}
				</TextField>
			);
		}
		return null;
	}


  render() {

    return (
      <div>
        <NavigationTabs
          title="Settings"
          set="settings"
          currentUser={this.props.currentUser}
          subtitle="Partner Subscription"
          activeRoute="/settings/partner-subscription" />
          <div>
           Select the amount you want to charge your customers monthly to access your workouts in your partner channel inside Fitbanx.
          </div>
                <div style={{ marginTop: 10, display: 'inline-grid', marginLeft: 0 }}>
                  {this.renderPlanSelect()} <br></br>
                  <Button
                    onClick={() => { this.updatePlan() }}
                    variant="contained"
                    color="primary">
                    <ButtonContent
                      text="Save Plan"
                      icon="chevron-right" />
                  </Button>
                </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.currentUser.user,
    payments: []
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getPlans: () => {
      return dispatch(getSubscriptionPlans());
    },
    fetchUser: () => {
      return dispatch(fetchUser());
    },
    updateUser: (data) => {
      return dispatch(updateUser(data));
    }
  }
}

export default withAuth(connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(PartnerSubscription));



// WEBPACK FOOTER //
// ./src/components/settings/PartnerSubscription.js